<template>
    <div class="height-percent-100">
        <div class="filter uk-flex uk-flex-middle" style="border-bottom:solid 1px #ccc">
            <el-input type="text" style="width:250px" :placeholder="$t('public.please_enter')" v-model="filterText"
                clearable></el-input>
            <el-button type="primary" icon="el-icon-search" class="btnClass" @click="searchTree"></el-button>
        </div>

        <div class="schema-tree">
            <trees ref="tree" @changeNode="changeNode" node-key="id" v-bind="$attrs"></trees>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            filterText: ''
        };
    },
    methods: {
        searchTree() {
            this.$refs.tree.$refs.tree.filter(this.filterText);
        },
        changeNode(e) {
            // 只有为展开状态 或 为叶子节点时才会触发
            this.$emit('changeNode', e.label);
        }
    }
};
</script>

<style scoped>
.schema-tree {
    height: calc(100% - 50px);
    overflow-y: scroll;
}

.filter {
    padding: 10px 5px;
}
</style>
